var UPLOAD_URL = 'https://up-z2.qiniup.com/';
var IMAGE_SIZE = {
    origin: '-pms_original',
    small: '-pms_thn',
    middle: '-pms_half',
    large: '-pms_wk',
};
var LOCATION_IMAGE_SIZE = {
    origin: '-location_original',
    small: '-linhuiba_watermark',
    middle: '-location_half',
    large: '-linhuiba_watermark',
};
var QINIU_DOMAIN = {
    image: 'https://pmsimage.location.pub',
    locationImage: 'https://img.linhuiba.com',
    locationVideo: 'https://videos.linhuiba.com',
    video: 'https://videos.location.pub',
    cert: 'https://certs.location.pub',
    temp: 'https://temps.location.pub',
    file: 'https://files.location.pub',
    case: 'https://cases.location.pub',
};
var BUCKETS = {
    image: 'pms-image',
    video: 'location-videos',
    cert: 'location-cert',
    temp: 'location-temp',
    file: 'location-files',
    case: 'location-cases',
    locationImage: 'image',
    locationVideo: 'video',
};
var formatImageUrl = function (url, type) {
    if (type === void 0) { type = 'middle'; }
    if (!url)
        return '';
    if (url.indexOf('linhuiba') > -1) {
        return "" + url + LOCATION_IMAGE_SIZE[type];
    }
    else {
        return "" + url + IMAGE_SIZE[type];
    }
};
export { LOCATION_IMAGE_SIZE, QINIU_DOMAIN, UPLOAD_URL, BUCKETS, IMAGE_SIZE, formatImageUrl, };
